import { render, staticRenderFns } from "./PostDocs.vue?vue&type=template&id=99448b64&scoped=true&"
import script from "./PostDocs.vue?vue&type=script&lang=js&"
export * from "./PostDocs.vue?vue&type=script&lang=js&"
import style0 from "./PostDocs.vue?vue&type=style&index=0&id=99448b64&prod&lang=css&"
import style1 from "./PostDocs.vue?vue&type=style&index=1&id=99448b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99448b64",
  null
  
)

export default component.exports